<template>
  <div class="table">
    <el-row v-if="tags.length>0">
      <p style="padding: 0px 10px;">已选择的ASL</p>
    </el-row>
    <div class="container" v-if="tags.length>0">
      <div class="handle-box">
        <div class="tag_dv">
          <div class="tag_dv_children" v-for="tag in tags" :key="tag.aslGroupCode" style="margin-bottom:10px">
            <el-tag closable @close="handleClose(tag)">
              {{tag.aslGroupName}}
            </el-tag>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="handle-box">
        <el-form :model="aslForm" ref="aslForm" label-position="right" label-width="120px" class="searchForm">
          <el-row>
            <el-col :span="24">
              <el-row :gutter="20">
                <el-col :span="6">
                  <el-form-item label="Category3" prop="category3Code">
                    <el-select :disabled="isDisabled" v-model="aslForm.category3Code" clearable style="width:100%">
                      <el-option :key="index" v-for="(item,index) in category3CodeOptions" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Sponsor" prop="sponsorName">
                    <el-input v-model="aslForm.sponsorName" placeholder="从供应商集团选择"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="ASL" prop="aslName">
                    <el-input v-model="aslForm.aslName" @blur="getAslName" placeholder="请输入内容"></el-input>
                  </el-form-item>
                </el-col>
                <el-col :span="6">
                  <el-form-item label="Ownership" prop="ownership">
                    <el-select v-model="aslForm.ownership" clearable style="width:100%" placeholder="请选择">
                      <el-option :key="index" v-for="(item,index) in ownershipOptions" :label="item.object" :value="item.key"></el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-col>
            <el-collapse-transition>
              <el-col :span="24" v-if="isShow">
                <el-row :gutter="20">
                  <el-col :span="6">
                    <el-form-item label="国内/国外" prop="domesticOrOverseas">
                      <el-select v-model="aslForm.domesticOrOverseas" clearable style="width:100%" placeholder="请选择">
                        <el-option :key="index" v-for="(item,index) in domesticOrOverseas" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="国家" prop="countryRegion">
                      <el-input v-model="aslForm.countryRegion" clearable style="width:100%"></el-input>
                    </el-form-item>
                  </el-col>
                  <el-col :span="6">
                    <el-form-item label="状态" prop="aslStatus">
                      <el-select v-model="aslForm.aslStatus" clearable filterable placeholder="请选择" style="width:100%">
                        <el-option :key="index" v-for="(item,index) in statusList" :label="item.object" :value="item.key"></el-option>
                      </el-select>
                    </el-form-item>
                  </el-col>
                </el-row>
              </el-col>
            </el-collapse-transition>
          </el-row>
          <el-row type="flex" justify="center" align="middle">
            <el-button size="mini" @click="onSearch" type="primary">查询</el-button>
            <el-button size="mini" @click="onReset" type="primary">重置</el-button>
            <span class="arrowDown" @click="isShow=!isShow">{{isShow?'收缩':'展开'}}<i :class="isShow?'el-icon-arrow-up iconBtn':'el-icon-arrow-down iconBtn'"></i></span>
          </el-row>
        </el-form>
      </div>
      <el-row class="action-btn-row">
        <el-button size="small" class="btn" type="primary" @click="onSelAsl">添加</el-button>
        <el-button size="small" class="btn" type="primary" @click="onConfirmAsl">确认</el-button>
        <!-- <el-button size="small" class="btn" type="primary" @click="onSel">选择</el-button> -->
      </el-row>
      <el-table ref="plxTable" :data="tableData" @selection-change="selectionChange" max-height="600" border stripe highlight-current-row>
        <el-table-column type="selection" width="55"></el-table-column>
        <el-table-column align="center" label="Category3" show-overflow-tooltip min-width="100" prop="category3Name"></el-table-column>
        <el-table-column align="center" label="Sponsor" show-overflow-tooltip min-width="90" prop="sponsorName"></el-table-column>
        <el-table-column align="center" label="ASL" show-overflow-tooltip min-width="90" prop="aslName"></el-table-column>
        <el-table-column align="center" label="Ownership" show-overflow-tooltip min-width="120" prop="ownership"></el-table-column>
        <el-table-column align="center" label="国内/国外" show-overflow-tooltip min-width="90" prop="domesticOrOverseasView"></el-table-column>
        <el-table-column align="center" label="国家" show-overflow-tooltip min-width="120" prop="countryRegion"></el-table-column>
        <el-table-column align="center" label="状态" show-overflow-tooltip min-width="120" prop="aslStatus"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="aslForm.pageNum" :page-sizes="pageSizeList" :page-size="aslForm.pageSize" :layout="pageLayout" :total="totalCount" :page-count="pages">
        </el-pagination>
      </div>
    </div>
  </div>
</template>
<script>
import IcSelect from "@/components/common/icSelect";
import rmcProtPurchaseApi from "@/api/rmcProtein/purchase";
import paginationMixin from '@/mixins/pagitionMixin';
import commonFunction from "@/utils/dataTableUtils";
import facilityList from "../ASL/facilityList.vue";

export default {
  name: 'rmcProtPurchase',
  mixins: [paginationMixin],
  props: ['id', 'rmcProtAslIdLists', 'aslTableData'],
  components: {
    IcSelect,
    facilityList,
  },
  data() {
    return {
      multipleSelection: [],
      idList: [],
      category3CodeOptions: [],
      ownershipOptions: [],
      domesticOrOverseas: [],
      statusList: [],
      tableData: [],
      ms_Permission: [],
      add_original_table_data: [],//存放原始数据
      tags: [],
      aslForm: {
        pageSize: 15,
        pageNum: 1,
        category3Code: "",
        sponsorName: "",
        aslName: "",
        ownership: "",
        domesticOrOverseas: "",
        countryRegion: "",
      },
      isShow: false,
      isDisabled: false,
      dialogVisible: false,
      totalCount: 0,
      pages: 1,
    }
  },
  created() {
    this.getSelection()
    this.ms_Permission = JSON.parse(localStorage.getItem('ms_Permission'))
  },
  methods: {
    queryData() {
      rmcProtPurchaseApi.findAsllist(this.aslForm).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
        if (this.rmcProtAslIdLists.length > 0) {
          this.$nextTick(() => {
            this.tableData.forEach(ele => {
              if (this.rmcProtAslIdLists.includes(ele.rmcProteinAslId)) {
                this.tags.push(ele)
              }
            })
          })
        }
        console.log('tags', this.tags);
      });
    },
    getSelection() {
      rmcProtPurchaseApi.getSelection(['rmc.RmcCategory3', 'rmc.RmcProteinAslOwnership', 'rmc.RmcDomesticOrOverseas', 'rmc.RmcProteinAslStatus']).then(res => {
        console.log('获取下拉框', res);
        if (this.ms_Permission.indexOf('RMC_DATAPERM_PORK') !== -1 && this.ms_Permission.indexOf('RMC_DATAPERM_POULTRY') !== -1) {
          this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
            return v.cascadeKey === 'protein'
          })
        }
        if (this.ms_Permission.indexOf('RMC_DATAPERM_POULTRY') !== -1 && this.ms_Permission.indexOf('RMC_DATAPERM_PORK') === -1) {
          this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
            return v.cascadeKey === 'protein'
          }).filter(ele => {
            return ele.object === 'Poultry'
          })
        }
        if (this.ms_Permission.indexOf('RMC_DATAPERM_PORK') !== -1 && this.ms_Permission.indexOf('RMC_DATAPERM_POULTRY') === -1) {
          this.category3CodeOptions = res.data['rmc.RmcCategory3'].filter((v) => {
            return v.cascadeKey === 'protein'
          }).filter(ele => {
            return ele.object === 'Pork'
          })
        }
        if (this.category3CodeOptions.length === 1) {
          this.$set(this.aslForm, 'category3Code', this.category3CodeOptions[0].key)
          this.isDisabled = true
        } else {
          this.isDisabled = false
        }
        this.domesticOrOverseas = res.data['rmc.RmcDomesticOrOverseas']
        this.ownershipOptions = res.data['rmc.RmcProteinAslOwnership']
        this.statusList = res.data['rmc.RmcProteinAslStatus']
        this.queryData()
      });
    },
    selectionChange(val) {
      this.multipleSelection = val;
      this.idList = []
      val.forEach(ele => {
        this.idList.push(ele.rmcProteinAslId)
      })
    },
    // onSel() {
    //   this.$emit('setAsl', JSON.stringify(this.multipleSelection))
    // },
    onSelAsl() {
      console.log('获取选中的数据', this.multipleSelection);
      for (let ele of this.multipleSelection) {
        // 如果有相同的值那么就返回对应的对象 如果没有则返回 undefined
        const itemJson = this.tags.find((item) => { return item.aslGroupCode === ele.aslGroupCode });
        console.log('itemJson', itemJson)
        if (itemJson) {
          this.$message.error(itemJson.aslGroupName + '已存在,请勿重复添加!')
          return
        }
      }
      this.tags = this.tags.concat(this.multipleSelection)
      this.$refs.plxTable.clearSelection();
      console.log('tags', this.tags);
    },
    onConfirmAsl() {
      console.log('tags', this.tags);
      this.$emit('setAsl', JSON.stringify(this.tags))
    },
    handleClose(tag) {
      this.tags.splice(this.tags.indexOf(tag), 1)
    },
    getAslName() {
      let obj = {
        aslGroupCode: "",
        aslGroupName: this.aslForm.aslName
      }
      if (!this.$route.query.id) {    //判断是新增的时候把输入的数据存到group
        this.$set(this.aslForm, 'aslGroupCode', this.aslForm.aslName)
      }
    },
    onSearch() {
      this.aslForm.pageNum = 1
      this.aslForm.pageSize = 15
      rmcProtPurchaseApi.findAsllist(this.aslForm).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
      // rmcProtPurchaseApi.findAsllist(this.aslForm).then(res => {
      //   var tempData= res.resultData.concat(this.add_original_table_data)
      //   this.totalCount = res.totalCount;
      //   // 默认勾选上已经存在的数据
      //   if (this.rmcProtAslIdLists.length > 0) {
      //     this.$nextTick(() => {
      //       this.tableData.forEach(ele => {
      //         if (this.rmcProtAslIdLists.includes(ele.rmcProteinAslId)) {
      //           this.$refs.plxTable.toggleRowSelection(ele, true);
      //         }
      //       })
      //     })
      //   }
      //   var hash = {}
      //   this.tableData = tempData.reduce(function (item, next) {
      //     hash[next.rmcProteinAslId] ? '' : hash[next.rmcProteinAslId] = true && item.push(next)
      //     return item
      //   }, [])
      //   console.log('add_original_table_data', this.add_original_table_data);
      //   console.log('tableData', this.tableData);
      // });
    },
    handleSizeChange(val) {
      this.aslForm.pageSize = val
      this.queryData()
    },
    handleCurrentChange(val) {
      this.aslForm.pageNum = val
      this.queryData()
    },
    onReset() {
      this.$refs['aslForm'].resetFields()
      this.aslForm = {
        pageSize: 15,
        pageNum: 1,
        documentNo: "",
        monthFrom: "",
        monthTo: "",
        category3Code: "",
        sponsorName: "",
        status: "",
      }
      if (this.category3CodeOptions.length === 1) {
        this.$set(this.aslForm, 'category3Code', this.category3CodeOptions[0].key)
        this.isDisabled = true
      } else {
        this.isDisabled = false
      }
      rmcProtPurchaseApi.findAsllist(this.aslForm).then(res => {
        this.tableData = res.resultData;
        this.totalCount = res.totalCount;
      });
    },
  },
  extends: commonFunction
}
</script>
<style scoped >
</style>
